import { SubscriptionFeature } from './types'
import { SubscriptionPaymentOptions } from '@/entities/payments/types'

export const unsubscribed_mostImportantFeatures: SubscriptionFeature[] = [
  {
    name: 'extra_update_bonus',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/updateBonusIcon.webp',
  },
  {
    name: 'free_reroll',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/rerollIcon.webp',
  },

  {
    name: 'free_gamed_box',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/freeBoxIcon.webp',
    basicValue: '24',
    plusValue: '12',
  },
]

export const unsubscribed_lessImportantFeatures: SubscriptionFeature[] = [
  {
    name: 'games_owned',
    basicAvailability: true,
    icon: '/assets/subscriptionRelated/featureIcons/gamesOwnedIcon.webp',
  },
  {
    name: 'items_owned',
    basicAvailability: true,
    icon: '/assets/subscriptionRelated/featureIcons/itemsOwnedIcon.webp',
  },

  {
    name: 'total_account_value',
    basicAvailability: true,
    icon: '/assets/subscriptionRelated/featureIcons/accountValueIcon.webp',
  },

  {
    name: 'total_playtime',
    basicAvailability: true,
    icon: '/assets/subscriptionRelated/featureIcons/totalPlaytimeIcon.webp',
  },
  {
    name: 'daily_playtime',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/dailyPlaytimeIcon.webp',
  },

  {
    name: 'account_age',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/accountAgeIcon.webp',
  },

  {
    name: 'registration_date',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/registrationDateIcon.webp',
  },
  {
    name: 'inventory_price',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/inventoryPriceIcon.webp',
  },

  {
    name: 'favorite_genre',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/favoriteGenreIcon.webp',
  },

  {
    name: 'recommendations',
    basicAvailability: false,
    icon: '/assets/subscriptionRelated/featureIcons/recommendationsIcon.webp',
  },
]

export const subscribed_mostImportantFeatures: SubscriptionFeature[] = [
  {
    name: 'extra_update_bonus',
    icon: '/assets/subscriptionRelated/featureIcons/updateBonusIcon.webp',
  },
  {
    name: 'free_reroll',
    icon: '/assets/subscriptionRelated/featureIcons/rerollIcon.webp',
  },

  {
    name: 'free_gamed_box',
    icon: '/assets/subscriptionRelated/featureIcons/freeBoxIcon.webp',
  },
]

export const subscribed_lessImportantFeatures: SubscriptionFeature[] = [
  {
    name: 'games_owned',
    icon: '/assets/subscriptionRelated/featureIcons/gamesOwnedIcon.webp',
  },
  {
    name: 'items_owned',
    icon: '/assets/subscriptionRelated/featureIcons/itemsOwnedIcon.webp',
  },

  {
    name: 'total_account_value',
    icon: '/assets/subscriptionRelated/featureIcons/accountValueIcon.webp',
  },

  {
    name: 'total_playtime',
    icon: '/assets/subscriptionRelated/featureIcons/totalPlaytimeIcon.webp',
  },

  {
    name: 'account_age',
    icon: '/assets/subscriptionRelated/featureIcons/accountAgeIcon.webp',
  },

  {
    name: 'registration_date',
    icon: '/assets/subscriptionRelated/featureIcons/registrationDateIcon.webp',
  },

  {
    name: 'daily_playtime',
    icon: '/assets/subscriptionRelated/featureIcons/dailyPlaytimeIcon.webp',
  },

  {
    name: 'inventory_price',
    icon: '/assets/subscriptionRelated/featureIcons/inventoryPriceIcon.webp',
  },

  {
    name: 'favorite_genre',
    icon: '/assets/subscriptionRelated/featureIcons/favoriteGenreIcon.webp',
  },

  {
    name: 'recommendations',
    icon: '/assets/subscriptionRelated/featureIcons/recommendationsIcon.webp',
  },
]

const basePath = `/assets/subscriptionRelated/featureIcons`
export const featuresList: SubscriptionFeature[] = [
  {
    name: 'advancedStatistics',
    plusAvailability: true,
    icon: `${basePath}/advancedStatistics.webp`,
  },
  {
    name: 'recommendations',
    plusAvailability: true,
    icon: `${basePath}/recommendations.webp`,
  },
  {
    name: 'improvedDrop',
    icon: `${basePath}/improvedDrop.webp`,
  },
  {
    name: 'moreGigi',
    icon: `${basePath}/moreGigi.webp`,
  },
  {
    name: 'moreGamed',
    icon: `${basePath}/moreGamed.webp`,
  },
  {
    name: 'freeCase',
    platinumValue: '6',
    plusValue: '12',
    icon: `${basePath}/freeCase.webp`,
  },
  {
    name: 'updateProgress',
    platinumValue: '12',
    plusValue: '24',
    icon: `${basePath}/updateProgress.webp`,
  },
]

export const subscriptionOptions: SubscriptionPaymentOptions[] = ['platinumDiscount', 'platinum', 'plus']
